import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  listPendingInvitations,
  acceptInvitation,
  declineInvitation,
} from '../api'
import { showSimpleSuccess, showSimpleError } from '@/lib/toast'

export function usePendingInvitations() {
  const queryClient = useQueryClient()

  const invitationsQuery = useQuery({
    queryKey: ['pendingInvitations'],
    queryFn: () => listPendingInvitations(),
  })

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['pendingInvitations'] })
    queryClient.invalidateQueries({ queryKey: ['workspaces'] })
  }

  const acceptMutation = useMutation({
    mutationFn: (invitationId) => acceptInvitation(invitationId),
    onSuccess: (data) => {
      showSimpleSuccess(data?.message || 'Invitation accepted successfully')
      invalidate()
    },
    onError: (error) => {
      showSimpleError(error.message || 'Failed to accept invitation')
    },
  })

  const declineMutation = useMutation({
    mutationFn: (invitationId) => declineInvitation(invitationId),
    onSuccess: (data) => {
      showSimpleSuccess(data?.message || 'Invitation declined')
      invalidate()
    },
    onError: (error) => {
      showSimpleError(error.message || 'Failed to decline invitation')
    },
  })

  const invitations = invitationsQuery.data?.data || []

  return {
    invitations,
    loading: invitationsQuery.isLoading,
    error: invitationsQuery.error,
    acceptInvitation: acceptMutation.mutateAsync,
    declineInvitation: declineMutation.mutateAsync,
    refetch: invitationsQuery.refetch,
  }
}

